import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { allowedPathsFor, roleHome as _roleHome } from '../lib/permissions';

export const RoleProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'admin') return children;       // admin sees everything
  if (adminOnly) return <Navigate to={_roleHome(user.role, user.is_team_lead)} replace />;

  const allowed = allowedPathsFor(user);             // Set or null
  if (!allowed) return children;                     // null = unrestricted (admin handled above)
  const isAllowed = Array.from(allowed).some((p) => location.pathname === p || location.pathname.startsWith(p + '/'));
  if (!isAllowed) return <Navigate to={_roleHome(user.role, user.is_team_lead)} replace />;
  return children;
};

export const roleHome = _roleHome;
